import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { FC } from 'react'
import { LargeProductSuitCardData } from '../types'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { Stack } from '@dtx-company/design-system/src'
import { asText } from '@prismicio/client'
import { prismicImageLoader } from '@app/common/src/utils/prismicImageLoader'
import CTAButton from './CTAButton'
import Image from 'next/image'
import PrismicText from '@app/prismic/src/components/PrismicText/PrismicText'
import ValuePropsColumns from './ValuePropsColumns'

const LargeProductSuitCardMobile: FC<{ data?: LargeProductSuitCardData }> = ({ data }) => {
  if (!data) return null

  const isCreateFlowcodeBtn = data.button_label?.toLowerCase() === 'create a flowcode'
  const hasValueProps =
    Boolean(data.value_props_list?.length) && Boolean(data.value_props_images?.length)

  return (
    <Box px="23px">
      <Box maxWidth="544px" mx="auto" flexDirection="column" alignItems="center">
        {data['logo-title']?.url && (
          <Stack
            alignItems="center"
            sx={{ mb: 1, img: { maxWidth: '153px', objectFit: 'contain' } }}
          >
            <Image
              width={153}
              height={153}
              src={data['logo-title']?.url}
              alt={data['logo-title']?.alt ?? 'logo'}
              loader={prismicImageLoader}
            />
          </Stack>
        )}
        <PrismicText
          richTextField={data.subheader}
          variant="display/medium"
          maxWidth="430px"
          lineHeight="30px"
          fontSize={{ _: '24px', md: '28px' }}
          textAlign="center"
        />
        {asText(data.description) && (
          <>
            <Spacer mb="16px" />
            <PrismicText
              richTextField={data.description}
              variant="body/medium"
              textAlign="center"
            />
          </>
        )}
        <Spacer mb="33px" />
        {data.image?.url && (
          <Image
            src={data.image?.url}
            alt={data.image?.alt ?? ''}
            width={549}
            height={268}
            loader={prismicImageLoader}
            style={{ objectFit: 'contain' }}
          />
        )}
        {hasValueProps && (
          <>
            <Spacer mt="33px" />
            <ValuePropsColumns
              valuePropsText={data.value_props_list}
              valuePropsImages={data.value_props_images}
            />
          </>
        )}
        <Spacer mb="33px" />
        <Box flexDirection="column" alignItems="center">
          <CTAButton
            label={data.button_label}
            href={isCreateFlowcodeBtn ? undefined : data.button_href?.url}
            onClick={isCreateFlowcodeBtn ? () => window.scroll(0, 0) : undefined}
            variant={data.button_variant}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default LargeProductSuitCardMobile
